import {Point} from "ol/geom";
import {viewFit} from "@/helpers/ol/ol-view";
import {setMapClickMarker} from "@/helpers/ol/ol-map-click-layer-helper";
import {addLocationMarker} from "@/helpers/ol/ol-route-helper";
import {getLatLonProjectionName, getViewProjection, getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {getDefaultZoom} from "@/helpers/ol/ol-zoom-helper.js";

export function goToCoordinate(coordinate) {
    let coordinates = coordinate.replace(/ /g, '').split(',');
    let    point = [parseFloat(coordinates[0]), parseFloat(coordinates[1])]

    // what is the projection of the coordinate 51.552444, 6.068559
    let source = 'EPSG:28992';
    if (!isRDCoordinate(point)) {
        point = point.reverse()
        source = getLatLonProjectionName()
    }

    const geometry = new Point(point).transform(source, getViewProjectionName());

    addLocationMarker(geometry.flatCoordinates)
    viewFit(geometry, undefined, getDefaultZoom())


}

export function isRDCoordinate(coord) {
    // RD coordinates typically fall within these bounds for the Netherlands
    const minX = -7000;
    const maxX = 300000;
    const minY = 289000;
    const maxY = 629000;

    return coord[0] >= minX && coord[0] <= maxX &&
        coord[1] >= minY && coord[1] <= maxY;
}
